import React, { FC } from 'react';
import { CommentedDecision } from '../../../../commentary/components/commented-decision/CommentedDecision';
import { SearchResultCommentarySubtitle } from './SearchResultCommentarySubtitle';
import { SearchCommentary } from './searchResultComment.types';
import styles from './search_result_commentary.module.scss';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { camelToSnake } from '../../../../caseUtils';
import { CommentarySummary } from '../../../../commentary/components/summary/CommentarySummary';
import { CommentaryTitle } from '../../../../commentary/components/title/CommentaryTitle';

type Props = {
  comment: SearchCommentary;
  originalQueryKey: string;
};

export const SearchResultCommentary: FC<Props> = ({
  comment,
  originalQueryKey,
}) => {
  const source = 'excerpt_results_comment';
  const reportClick = () => {
    doctrineAnalytics('Search CommentaryDecisionClicked', {
      ...camelToSnake(comment),
      reportOriginalQueryKey: true,
    });
  };
  const sendTrackingEvent = () => {
    doctrineAnalytics('Search ResultClicked', {
      type: 'comment',
      position: comment.position,
      commentaire_id: comment.commentaireId,
      url: comment.url,
      original_query_key: originalQueryKey,
    });
  };

  return (
    <>
      <div className={styles.wrapper}>
        <CommentaryTitle
          position={comment.position}
          onClick={sendTrackingEvent}
          dataTestId="search-comment-title-link"
          commentary={comment}
          source={source}
        />
        <SearchResultCommentarySubtitle comment={comment} />
        {Boolean(comment.textShort) && (
          <CommentarySummary
            source={source}
            commentary={comment}
            onClick={sendTrackingEvent}
            position={comment.position}
          />
        )}
      </div>
      <CommentedDecision
        decision={comment.decision}
        originalQueryKey={originalQueryKey}
        reportClick={reportClick}
        source={`${source}_arret`}
      />
    </>
  );
};
